import { createStore } from "vuex"
import user from "./modules/user/user";
import users_filter from "./modules/users/users_filter";
import reduction from "./modules/reduction/reduction";
export default createStore({
    modules: {
        user,
        users_filter,
        reduction
    }
});
